import { Navigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
import UserManagement from 'src/pages/Admin/User_Management/UserManagement';
import {
  canAccessTownshipConfiguration,
  getTownshipConfigurationDeniedRedirect,
  isTownshipConfigurationTownshipAllowed
} from 'src/utils/townshipAdminAccess';

/** User Management is admin configuration; same access rules as Township Configuration (Admin only in practice). */
const UserManagementRoute = () => {
  const { townshipId } = useParams<{ townshipId: string }>();
  const userDetails = useSelector((store: RootState) => store.user.userDetails);

  const isAdmin = userDetails?.UserRole === 'Admin';

  if (!isAdmin || !canAccessTownshipConfiguration(userDetails)) {
    return (
      <Navigate
        to={getTownshipConfigurationDeniedRedirect(userDetails)}
        replace
      />
    );
  }

  if (!isTownshipConfigurationTownshipAllowed(userDetails, townshipId)) {
    return (
      <Navigate
        to={getTownshipConfigurationDeniedRedirect(userDetails)}
        replace
      />
    );
  }

  return <UserManagement />;
};

export default UserManagementRoute;
